import Swiper from 'swiper';
import { Keyboard } from 'swiper/modules';

import gallery from './Gallery';

export default function productGallery() {
  let onPageSwiper: Swiper | null = null;

  function initImageGridSlider() {
    if (window.innerWidth < 1024
      && onPageSwiper === null
      && document.querySelector('.on-page-gallery-slider') !== null
    ) {
      onPageSwiper = new Swiper('.on-page-gallery-slider', {
        centeredSlides: true,
        loop: true,
        slidesPerView: 1,
        modules: [Keyboard],
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
      });
    }
  }

  function init() {
    initImageGridSlider();
    window.addEventListener('resize', initImageGridSlider);
  }

  const parent = gallery();

  return {
    ...parent,
    downloadArchiveEmail: '',
    downloadArchiveSuccess: false,
    downloadArchiveEmailInvalid: false,
    downloadArchiveError: '',
    downloadArchiveDialogOpen: false,
    downloadArchiveDialogSubmitting: false,
    validateEmail(email: string) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        );
    },
    submitDownloadForm() {
      if (!this.validateEmail(this.downloadArchiveEmail)) {
        this.downloadArchiveEmailInvalid = true;
      } else {
        // @ts-ignore
        const form = document.querySelector('#archive-download-form') as HTMLFormElement;
        if (form) {
          this.downloadArchiveDialogSubmitting = true;
          this.resetDownloadArchiveModal();
          const formData = new FormData(form);
          fetch(form.action, {
            method: 'POST',
            body: formData,
          })
            .then((response) => {
              this.downloadArchiveDialogSubmitting = false;
              if (!response.ok) {
                return response.text()
                  .then((errorText) => {
                    throw new Error(errorText);
                  });
              }
              return response.json();
            })
            .then((data) => {
              if (data.success) {
                this.downloadArchiveSuccess = true;
              } else {
                this.downloadArchiveError = data.error;
              }
            })
            .catch(() => {
              this.downloadArchiveError = 'An unexpected error occurred';
            });
        }
      }
    },
    resetDownloadArchiveModal() {
      this.downloadArchiveError = '';
      this.downloadArchiveEmailInvalid = false;
      this.downloadArchiveSuccess = false;
    },
    closeDownloadArchiveModal() {
      this.downloadArchiveDialogOpen = false;
      setTimeout(() => {
        this.resetDownloadArchiveModal();
        this.downloadArchiveEmail = '';
      }, 300);
    },
    init() {
      parent.init.call(this);
      init();
    },
  };
}
